import { render } from "./Companies-page.vue?vue&type=template&id=3e4c3474&scoped=true"
import script from "./Companies-page.vue?vue&type=script&lang=js"
export * from "./Companies-page.vue?vue&type=script&lang=js"

import "./Companies-page.vue?vue&type=style&index=0&id=3e4c3474&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4c3474"]])

export default __exports__